// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__2H2id","infected":"Cards_infected__1V-UM","recovered":"Cards_recovered__1Q8A7","deaths":"Cards_deaths__3xmc-"};